module.exports = __webpack_public_path__ + "img/WindRanger.853de02d.png";